import { Box, IconButton } from "@mui/material";
import { FC } from "react";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import fallbackVideoBanner from "../../assets/home-owner/images/video.png";

export interface VideoCardProps {
  video: {
    title: string;
    description: string;
    videoBanner: string;
    url?: string;
  };
  onPlay?: (url: string, title: string) => void;
}

const getPreferredBanner = (url: string) => {
  if (!url.includes("i.vimeocdn.com/video/")) {
    return url;
  }
  return url.replace(/-d_[^?]+(?=\?|$)/, "-d_360x480");
};

export const VideoCard: FC<VideoCardProps> = ({ video, onPlay }) => (
  <Box
    className="video-card"
    sx={{
      width: "100%",
      height: 0,
      pb: "133.333%",
      borderRadius: 3,
      overflow: "hidden",
      position: "relative",
      "@supports (aspect-ratio: 3 / 4)": {
        height: "auto",
        pb: 0,
        aspectRatio: "3 / 4",
      },
    }}
  >
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <IconButton
        size="small"
        onClick={() => {
          if (video.url) {
            if (onPlay) {
              onPlay(video.url, video.title);
            } else {
              window.open(video.url, "_blank", "noopener,noreferrer");
            }
          }
        }}
        aria-label={video.url ? `Play ${video.title}` : "Video unavailable"}
        sx={{
          width: 72,
          height: 72,
          minWidth: 72,
          borderRadius: "100%",
          backgroundColor: "rgba(0,0,0,0.7)",
          cursor: video.url ? "pointer" : "not-allowed",
          "&:hover": {
            backgroundColor: "rgba(0,0,0,0.9)",
          }
        }}
      >
        <PlayArrowIcon sx={{ color: "#fff", fontSize: 32 }} />
      </IconButton>
    </Box>
    <Box
      component="img"
      src={getPreferredBanner(video.videoBanner)}
      alt={video.title}
      onError={(event) => {
        event.currentTarget.onerror = null;
        event.currentTarget.src = fallbackVideoBanner;
      }}
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: 1,
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }}
    />
  </Box>
); 
